import { render, staticRenderFns } from "./MaterialDeliveryTable.vue?vue&type=template&id=3fdb0432&scoped=true"
import script from "./MaterialDeliveryTable.vue?vue&type=script&lang=js"
export * from "./MaterialDeliveryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdb0432",
  null
  
)

/* custom blocks */
import block0 from "@/components/CoreMaterial/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FCoreMaterial%2FMaterialDelivery%2FMaterialDeliveryTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports